import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Button, ButtonBase } from "@material-ui/core";

const ButtonLoadMore = ( { remaining, onClickLoadMore } ) => 
    <Button onClick={onClickLoadMore} color="primary">Show More Items {remaining && parseInt(remaining) > 0 ? '(' + (remaining) + ' remaining)' : ''}</Button>

export default ButtonLoadMore;

ButtonLoadMore.propTypes = {
    remaining: PropTypes.number,
};
